export default __webpack_public_path__ + "static/card4-fb9b3cf2600985dae2905250f53e6418.webp";